import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  vipCardData: {},
  pageFlag: 'create'
}

export const vipCardSlice = createSlice({
  name: 'vipCard',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setVipCardDataAction: (state, action) => {
      state.vipCardData = action.payload
    },
    setVipCardPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setVipCardDataAction, setVipCardPageFlagAction } = vipCardSlice.actions

// Selectors
export const selectVipCardData = (state) => state.vipCard.vipCardData
export const selectVipCardPageFlag = (state) => state.vipCard.pageFlag

// Reducer
export default vipCardSlice.reducer